import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
import { Download, Calendar, Mail, Linkedin, Mic, FileText, BookOpen } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-20 md:py-32 bg-dark-bg" data-id="element-118">
      <div className="max-w-5xl mx-auto px-4 md:px-8" data-id="element-119">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-120">
          {/* Header */}
          <motion.div variants={fadeInUp} className="mb-16 text-center" data-id="element-121">
            <span className="font-sans text-gold/80 tracking-widest uppercase text-xs font-semibold mb-3 block" data-id="element-122">
              Get In Touch
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-5" data-id="element-123">
              Let's Connect
            </h2>
            <p className="text-slate-300 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-124">
              Actively exploring CTO, Chief Digital Officer, and board-level
              opportunities in financial services, insurance, and regulated
              industries. Open to executive search conversations.
            </p>
          </motion.div>

          {/* Contact Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-125">
            {/* Direct Inquiry */}
            <motion.div variants={fadeInUp} className="bg-dark-card border border-dark-border rounded-xl p-8" data-id="element-126">
              <div className="flex items-center gap-3 mb-6" data-id="element-127">
                <div className="w-10 h-10 rounded-lg bg-dark-elevated border border-gold/20 flex items-center justify-center" data-id="element-128">
                  <Mail className="w-5 h-5 text-gold" data-id="element-129" />
                </div>
                <h3 className="text-white font-bold text-lg" data-id="element-130">
                  Executive Recruiters & Boards
                </h3>
              </div>
              <div className="space-y-4" data-id="element-131">
                <div data-id="element-132">
                  <div className="text-slate-500 text-xs uppercase tracking-wider mb-1" data-id="element-133">
                    Email
                  </div>
                  <a href="mailto:michael.parks@exec.com" className="text-gold hover:text-gold/80 transition-colors font-medium" data-id="element-134">
                    michael.parks@exec.com
                  </a>
                </div>
                <div data-id="element-135">
                  <div className="text-slate-500 text-xs uppercase tracking-wider mb-1" data-id="element-136">
                    LinkedIn
                  </div>
                  <a href="https://www.linkedin.com/in/michael-parks" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors flex items-center gap-2" data-id="element-137">
                    <Linkedin className="w-4 h-4" data-id="element-138" />
                    /in/michael-parks
                  </a>
                </div>
                <div className="pt-2 border-t border-dark-border" data-id="element-139">
                  <p className="text-slate-500 text-sm" data-id="element-140">
                    Responds within 24 business hours. NDA available upon
                    request.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Opportunities */}
            <motion.div variants={fadeInUp} className="bg-dark-card border border-dark-border rounded-xl p-8" data-id="element-141">
              <div className="flex items-center gap-3 mb-6" data-id="element-142">
                <div className="w-10 h-10 rounded-lg bg-dark-elevated border border-gold/20 flex items-center justify-center" data-id="element-143">
                  <Mic className="w-5 h-5 text-gold" data-id="element-144" />
                </div>
                <h3 className="text-white font-bold text-lg" data-id="element-145">
                  Roles of Interest
                </h3>
              </div>
              <div className="space-y-3" data-id="element-146">
                {['Chief Technology Officer (CTO)', 'Chief Digital Officer (CDO)', 'Board Director — Technology Committee', 'PE Portfolio Advisory — Financial Services', 'Keynote Speaking & Executive Panels'].map(role => <div key={role} className="flex items-center gap-2" data-id="element-147">
                    <div className="w-1.5 h-1.5 rounded-full bg-gold/60 flex-shrink-0" data-id="element-148"></div>
                    <span className="text-slate-300 text-sm" data-id="element-149">{role}</span>
                  </div>)}
                <div className="pt-2 border-t border-dark-border" data-id="element-150">
                  <p className="text-slate-500 text-sm" data-id="element-151">
                    Preference for financial services, insurance, and regulated
                    industries.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* CTAs */}
          <motion.div variants={fadeInUp} className="flex flex-col sm:flex-row justify-center flex-wrap gap-4" data-id="element-152">
            <a href="mailto:michael.parks@exec.com" className="px-8 py-4 bg-gold text-dark-bg font-bold rounded hover:bg-gold/90 transition-all flex items-center justify-center gap-2" data-id="element-153">
              <Calendar className="w-4 h-4" data-id="element-154" />
              Schedule a Conversation
            </a>
            <a href="https://heyzine.com/flip-book/e2c9bcea18.html" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-transparent border border-dark-border text-slate-300 font-medium rounded hover:border-gold/40 hover:text-white transition-all flex items-center justify-center gap-2" data-id="element-155">
              <FileText className="w-4 h-4" data-id="element-156" />
              View Executive Resume
            </a>
            <a href="https://heyzine.com/flip-book/e53f06ab30.html" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-transparent border border-dark-border text-slate-300 font-medium rounded hover:border-gold/40 hover:text-white transition-all flex items-center justify-center gap-2" data-id="element-157">
              <BookOpen className="w-4 h-4" data-id="element-158" />
              Leadership Philosophy
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}